"use client";
import type { Locale } from "@/types";
import ButtonSelector from "./ButtonSelector";
import { LanguageSelectorVariant } from "./constants";
import DropdownSelector from "./DropdownSelector";

export interface LocalizedPath {
  locale: Locale;
  path: string;
}

export interface LanguageSelectorProps {
  list: LocalizedPath[];
  variant?: LanguageSelectorVariant;
}

export default function LanguageSelector(props: LanguageSelectorProps) {
  const { list, variant = LanguageSelectorVariant.Button } = props;

  switch (variant) {
    case LanguageSelectorVariant.Button:
      return <ButtonSelector list={list} />;

    case LanguageSelectorVariant.Dropdown:
      return <DropdownSelector list={list} />;

    default:
      return null;
  }
}
